// extracted by mini-css-extract-plugin
export default {"containerDay":"daily-styles_containerDay__5hmDH","numberCalendar":"daily-styles_numberCalendar__kPaDd"};